import type { AdditionalData } from '@pba/react-components';
import { useQueryClient } from '@tanstack/react-query';
import { useUser } from 'features/auth';

export const useGetErrorDetails = () => {
  const queryClient = useQueryClient();
  const user = useUser({ requiredAuth: false });

  return (): AdditionalData[] => [
    { data: user ?? 'Not logged in', title: 'User' },
    {
      data: queryClient
        .getQueryCache()
        .getAll()
        .map((query) => ({
          data: query.state.data,
          error: query.state.error?.message,
          queryKey: query.queryKey,
          status: query.state.status,
          updatedAt: query.state.dataUpdatedAt > 0 ? new Date(query.state.dataUpdatedAt).toISOString() : undefined,
        })),
      title: 'Query cache',
    },
  ];
};
